import { IntakeLabelCollection } from '@govalta-emu/alss-common';
import { ProgramList } from '../../constants/program-list';

const diaName = ProgramList.dia;
const incomeSupportName = ProgramList.incomeSupport;
const aishName = ProgramList.aish;
const adpName = ProgramList.adap;

export const AishPreScreenLabels: IntakeLabelCollection = {
  pageTitle: {
    label: `Is ${diaName.abbreviation} right for you?`,
  },
  pageDescription: {
    label: 'Answer a few questions to see if you may be',
  },
  reapplying: {
    label: `Are you waiting for an outcome on a previous ${aishName.abbreviation} application and wondering if you should reapply now?`,
  },
  birthdate: {
    label: 'What is your birthdate?',
  },
  hasOas: {
    label: 'Do you receive Old Age Security (OAS) benefits?',
  },
  immigrationStatus: {
    label: 'What is your citizenship/immigration status?',
  },
  immigrationStatusOther: {
    label: 'Please explain your immigration status',
  },
  livesInAlberta: {
    label: 'Where do you live?',
  },
  livesInPrison: {
    label: 'Do you live in a correctional institution (e.g. prison)?',
  },
  releasePlan: {
    label: 'Do you have a release plan within the next 6 months?',
  },
  livesInMentalFacility: {
    label: 'Do you live in a mental health facility?',
  },
  dischargePlan: {
    label: 'Do you have a discharge plan in the next 6 months?',
  },
  receivedDIABenifits: {
    label: `Have you received ${aishName.abbreviation} or ${adpName.abbreviation} benefits in the last 24 months?`,
  },
};

export const AishPreScreenOnBehalfLabels: IntakeLabelCollection = {
  pageTitle: {
    label: `Is ${diaName.abbreviation} right for this person?`,
  },
  pageDescription: {
    label: 'Answer a few questions about the person you are applying for to see if they may be',
  },
  reapplying: {
    label: `Is the person you are applying for waiting for an outcome on a previous ${aishName.abbreviation} application and wondering if they should reapply?`,
  },
  birthdate: {
    label: 'What is their birthdate?',
  },
  hasOas: {
    label: 'Do they receive Old Age Security (OAS) benefits?',
  },
  immigrationStatus: {
    label: 'What is their citizenship/immigration status?',
  },
  immigrationStatusOther: {
    label: 'Please explain their immigration status',
  },
  livesInAlberta: {
    label: 'Where do they live?',
  },
  livesInPrison: {
    label: 'Do they live in a correctional institution (e.g. prison)?',
  },
  releasePlan: {
    label: 'Do they have a release plan within the next 6 months?',
  },
  livesInMentalFacility: {
    label: 'Do they live in a mental health facility?',
  },
  dischargePlan: {
    label: 'Do they have a discharge plan in the next 6 months?',
  },
  receivedDIABenifits: {
    label: `Have they received ${aishName.abbreviation} or ${adpName.abbreviation} benefits in the last 24 months?`,
  },
};
